import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import { ExperimentsSymbol, PageFeatureConfigSymbol, Props, StructureAPI } from '@wix/thunderbolt-symbols'
import type { IInteractionsDefinition, IInteractionsServiceConfig } from '@wix/site-service-interactions/definition'
import { InteractionsDefinition as definition } from '@wix/site-service-interactions/definition'
import { InteractionsService as impl } from '@wix/site-service-interactions/implementations'
import type { InteractionsConfig } from '@wix/thunderbolt-becky-types'
import { getCompIdToTemplateCompPath } from '@wix/thunderbolt-commons'
import { assignCompPathToSiteInteractionsConfig } from './siteInteractionsConfigUtils'
import { EMPTY_INTERACTIONS_CONFIG } from './constants'

export const SiteInteractionsService = withDependencies(
	[named(PageFeatureConfigSymbol, 'interactions' as const), StructureAPI, Props, ExperimentsSymbol] as const,
	(
		{ interactionsConfig }: { interactionsConfig: InteractionsConfig },
		structure,
		props,
		experiments
	): ServiceProvider<IInteractionsDefinition, typeof impl> => {
		const compIdToTemplateCompPath = getCompIdToTemplateCompPath(structure, { props, experiments })
		const configWithTemplateCompPath = assignCompPathToSiteInteractionsConfig(
			interactionsConfig,
			compIdToTemplateCompPath
		) as unknown as IInteractionsServiceConfig
		return {
			definition,
			impl,
			config: configWithTemplateCompPath,
			// @ts-expect-error - the generated config is serializable and does not contain functions/dom elements/class instances
			platformConfig: configWithTemplateCompPath,
		}
	}
)

export const siteSiteInteractionsService = withDependencies(
	[],
	(): ServiceProvider<IInteractionsDefinition, typeof impl> => ({
		definition,
		impl,
		config: EMPTY_INTERACTIONS_CONFIG as unknown as IInteractionsServiceConfig,
		// @ts-expect-error - empty config is serializable
		platformConfig: EMPTY_INTERACTIONS_CONFIG,
	})
)
